module.exports = __webpack_public_path__ + "src/images/measurements/waistToHip.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/measurements/waistToHip.jpg
// module id = 1164
// module chunks = 0